// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2j6Vh","toggle":"styles_toggle__jbbvH","preview":"styles_preview__22RE8"};